<div class="container" [class.mobile]="isMobile">
  <div class="main-title">{{'Liens utiles' | translate}}</div>
  <div class="admin" *ngIf="isAdmin">
    <button class="wire-btn skalaki" (click)="modalLink(linkTemplate)">Add Link</button>
  </div>
  <div class="link-container">
    <div class="column" *ngFor="let column of links; let i = index">
      <div class="link" *ngFor="let link of links[i]" (click)="modalLink(linkTemplate, link)">
        <div class="title">
          {{getLinkProperty(link, 'name')}}
        </div>
        <div class="description">
          {{getLinkProperty(link, 'description')}}
        </div>
        <div class="footer">
          <a class="wire-btn" (click)="openLink(link)">
            {{'Visiter' | translate}} <i class="fa fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #linkTemplate>
  <div class="modal-content">
    <div class="header">
      <span *ngIf="!linkModel.id">Add</span><span *ngIf="linkModel.id">Edit</span> Link
      <div class="close" (click)="close()">
        <i class="fa fa-times"></i>
      </div>
    </div>
    <div class="content">
      <div class="form">
        <div class="form-group">
          <div class="label">Name Fr</div>
          <input type="text" required id="nameFr" [(ngModel)]="linkModel.nameFr" #nameFr="ngModel" />
          <div *ngIf="nameFr.invalid && (nameFr.dirty || nameFr.touched)">
            Name fr is required
          </div>
        </div>
        <div class="form-group">
          <div class="label">Name En</div>
          <input type="text" required id="nameEn" [(ngModel)]="linkModel.nameEn" #nameEn="ngModel" />
          <div *ngIf="nameEn.invalid && (nameEn.dirty || nameEn.touched)">
            Name en is required
          </div>
        </div>
        <div class="form-group">
          <div class="label">Description Fr</div>
          <textarea rows="6" type="text" required id="descriptionFr" [(ngModel)]="linkModel.descriptionFr"
            #descriptionFr="ngModel"></textarea>
          <div *ngIf="descriptionFr.invalid && (descriptionFr.dirty || descriptionFr.touched)">
            Description fr is required
          </div>
        </div>
        <div class="form-group">
          <div class="label">Description En</div>
          <textarea rows="6" type="text" required id="descriptionEn" [(ngModel)]="linkModel.descriptionEn"
            #descriptionEn="ngModel"></textarea>
          <div *ngIf="descriptionEn.invalid && (descriptionEn.dirty || descriptionEn.touched)">
            Description en is required
          </div>
        </div>
        <div class="form-group">
          <div class="label">Link</div>
          <input type="text" required id="linkLink" [(ngModel)]="linkModel.link" #linkLink="ngModel" />
          <div *ngIf="linkLink.invalid && (linkLink.dirty || linkLink.touched)">
            Link is required
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <button class="wire-btn" (click)="saveLink()">Save</button>
      <button *ngIf="linkModel.id" class="wire-btn" (click)="deleteLink()">Delete</button>
      <button class="wire-btn default" (click)="close()">Cancel</button>
    </div>
  </div>
</ng-template>

<p-confirmDialog header="Delete Link" icon="pi pi-exclamation-triangle"></p-confirmDialog>